import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BiLogIn } from "react-icons/bi";

const Header = ({ data }) => {
  // const [toggle, setToggle] = useState(false);
  const token = localStorage.getItem("Popweb");
 
  const [htmlData, setHtmlData] = useState("");
  // const setState1 = () => {
  //   if (toggle === true) {
  //     setToggle(false);
  //   } else {
  //     setToggle(true);
  //   }
  // };
  useEffect(() => {
    if (typeof data === "string") {
      let formattedData = data
        .replace(/<Link to="(.*?)">(.*?)<\/Link>/g, '<a href="$1">$2</a>') // Convert <Link> to <a>
        .replace(/{\/\*.*?\*\/}/g, "") // Remove JSX comments
        .replace(/<BiLogIn \/>/g, "🔑")
        .replace(
          /<a href="\/signin">Login <BiLogIn \/><\/a>/g,
          token
            ? ""
            : '<a href="/signin" style="text-decoration: none; color: #000;">Login 🔑</a>'
        )
        .replace(
          /<a href="\/signin" onClick={logout}>Log out<\/a>/g,
          token
            ? '<a href="/signin" onClick="logout()" style="text-decoration: none; color: #000;">Log out</a>'
            : ""
        ); // Replace <BiLogIn /> with an icon

      // Handle token-based login/logout display
      formattedData = formattedData.replace(
        /{token == null \? \((.*?)\) : \((.*?)\)}/g,
        token ? "$2" : "$1"
      );

      setHtmlData(formattedData);
    }
  }, [data, token]);


  const logout = () => {
    localStorage.clear();
  };
  return (
    <div style={{display:"flex" , justifyContent: "center" , alignItems:"center" , gap:"12px"}} >
      <div style={{width: "80%"}}  dangerouslySetInnerHTML={{ __html: htmlData }} />
      {token == null ?
                <div className="nav-item">
                  <Link className="nav-link text-black" to="/signin">
                    Login <BiLogIn />
                  </Link>
                </div> :
                <div className="nav-item">
                  <Link className="nav-link text-black" to="/signin" onClick={logout}>
                    Log out
                  </Link>
                </div>
              }
    </div>
  );
};

export default Header;
